// extracted by mini-css-extract-plugin
export var tosLink = "_4y-0";